import styled from 'styled-components';

type LoadingScreenProps = {
	isVisible: boolean;
};

export const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  position: fixed;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
  left: 0;
  top: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20;
  z-index: 9999;
`;
export const LogoSpinner = styled.img`
  width: 60px;
  height: 60px;
  animation: spinner-d3wgkg 1.5s infinite linear;

  @keyframes spinner-d3wgkg {
    to {
      transform: rotate(1turn);
    }
  }
`;

export function LoadingScreen({ isVisible }: LoadingScreenProps) {
	const handlerLogo = require('../../assets/images/logo.png');

	if (!isVisible) return null;

	return (
		<Container>
			<LogoSpinner src={handlerLogo} alt='Handler' />
		</Container>
	);
}
